import { render, staticRenderFns } from "./AnnotatorSelect.vue?vue&type=template&id=7101ce7a&"
import script from "./AnnotatorSelect.vue?vue&type=script&lang=js&"
export * from "./AnnotatorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports